export const adultoCookieKey = "adultocz_local";
export const VERIFF_AV = "veriff_av";
export const VERIFF_AGE_ESTIMATION = "veriff_age_estimation";
export const YOTI_AV = "age_estimationasync";

// 30 minutes - the same as the session timeout for BE for AV provider response - possible to change in the future if needed based on Market feedback
export const uuidCookieTtl = 30 * 60;
